import Constants from 'expo-constants'
import { Dimensions, StatusBar } from 'react-native'
import theme from '../../../../theme'
import { opacity } from 'react-native-redash'

const deviceWidth = Dimensions.get('window').width

const styles = {
    Video: {
        alignSelf: 'center',
        width: 320,
        height: 200,
    },
    ButtonVideoPlayer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    // Componentes
    videoPlayer: {
        width: '100%',
        // El alto lo define el contenido (imagen/video) vía su aspectRatio dinámico
        //imageAlign: 'fit'
    },
    thumbnailVideoImage: {
        width: 200,
        height: 200,
    },
    //Background de medias
    backgroundImage: {
        width: '100%',
        // Sin aspectRatio fijo: deja que el hijo controle el alto
        alignItems: 'center',
        justifyContent: 'center',
    },
    // Indicador de pagina en slide:
    floatPageIndicator: {
        position: 'absolute',
        top: 10,
        left: 10,
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 10,
        backgroundColor: 'white',
        zIndex: 10,
    },
    floatPageIndicatorText: {
        color: 'black',
        fontSize: 12,
        fontWeight: 'bold',
    },
    bulletsContainer: {
        flexDirection: 'row',
        height: 18,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        zIndex: 10,
    },
    bulletsIndicator: {
        flexDirection: 'row',
        paddingVertical: 5,
        paddingHorizontal: 10,
        position: 'absolute',
        bottom: 0,
        alignSelf: 'center',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        zIndex: 10,
    },
    currentBulletIndicator: {
        width: 25,
        height: 6,
        borderRadius: 5,
        backgroundColor: theme.colors.colorPrimary,
        opacity: 1.0,
        marginHorizontal: 2,
        zIndex: 10,
    },
    circleBulletIndicator: {
        width: 6,
        height: 6,
        borderRadius: 5,
        // Color neutro para distinguirlos del resaltado
        backgroundColor: theme.colors.textSecondary,
        opacity: 0.6,
        marginHorizontal: 2,
        zIndex: 10,
    },
    containerDescription: {
        flex: 1,
        marginTop: 12,
        marginBottom: 0,
        paddingHorizontal: 12,
    },
    descriptionModule: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    //PDF
    pdf: {
        width: '100%',
        // No forzar 1:1: el componente hijo maneja su tamaño
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
        backgroundColor: 'red',
    },
    spacer2: {
        height: 80,
    },
}

export default styles
